import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  display_name: string;
  code: string;
  is_active: boolean;
}

export const useCreateDivision = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(`${env.verifyServiceUrl}common/division/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
